<template>
  <div class="a2p-copy-block">
    <div class="a2p-copy-head">
      <div class="label">
        <strong>{{ title }}</strong>
        <span v-if="sub" class="sub">{{ sub }}</span>
      </div>
      <button type="button" class="a2p-copy-btn" :class="{ copied }" @click="copy">
        <span v-if="copied">✓ Copied</span>
        <span v-else>Copy</span>
      </button>
    </div>
    <div class="a2p-copy-body" v-html="formattedBody"></div>
  </div>
</template>

<script>
import { substituteCompliance } from '@/utils/a2pValidation';

const inlineMd = (s) =>
  s
    // escape HTML first
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // then **bold**
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

export default {
  name: 'A2PCopyBlock',
  props: {
    title: { type: String, required: true },
    sub: { type: String, default: '' },
    body: { type: String, required: true },
    officePhone: { type: String, default: '' },
    officeEmail: { type: String, default: '' },
    messageFrequency: { type: String, default: '' },
  },
  data() {
    return { copied: false };
  },
  computed: {
    substituted() {
      return substituteCompliance(this.body, {
        officePhone: this.officePhone,
        officeEmail: this.officeEmail,
        messageFrequency: this.messageFrequency,
      });
    },
    formattedBody() {
      // render bold + highlight any remaining [OFFICE PHONE] / [OFFICE EMAIL] placeholders
      let html = inlineMd(this.substituted);
      html = html
        .replace(/\[OFFICE PHONE\]/g, '<span class="ph">[OFFICE PHONE]</span>')
        .replace(/\[OFFICE EMAIL\]/g, '<span class="ph">[OFFICE EMAIL]</span>');
      return html;
    },
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.substituted);
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      } catch (e) {
        console.error('Copy failed:', e);
      }
    },
  },
};
</script>
